export const unMaskSpecialChacaracters = (value) => {
    return value.replace(/[^\d]+/g,'')
}

export const maskPhone = (phone) => {
    var r = phone.replace(/\D/g, "");
    r = r.replace(/^0/, "");
    if (r.length > 10) {
      r = r.replace(/^(\d\d)(\d{5})(\d{4}).*/, "($1) $2-$3");
    } else if (r.length > 5) {
      r = r.replace(/^(\d\d)(\d{4})(\d{0,4}).*/, "($1) $2-$3");
    } else if (r.length > 2) {
      r = r.replace(/^(\d\d)(\d{0,5})/, "($1) $2");
    } else {
      r = r.replace(/^(\d*)/, "($1");
    }
    return r;
}

export const cpfCnpj = (cnpj_cnpf) =>  {
    //Remove tudo o que não é dígito
    cnpj_cnpf=cnpj_cnpf.replace(/\D/g,"")
 
    if (cnpj_cnpf.length < 14) { //CPF
 
        //Coloca um ponto entre o terceiro e o quarto dígitos
        cnpj_cnpf=cnpj_cnpf.replace(/(\d{3})(\d)/,"$1.$2")
 
        //Coloca um ponto entre o terceiro e o quarto dígitos
        //de nocnpj_cnpfo (para o segundo bloco de números)
        cnpj_cnpf=cnpj_cnpf.replace(/(\d{3})(\d)/,"$1.$2")
 
        //Coloca um hífen entre o terceiro e o quarto dígitos
        cnpj_cnpf=cnpj_cnpf.replace(/(\d{3})(\d{1,2})$/,"$1-$2")
 
    } else { //CNPJ
 
        //Coloca ponto entre o segundo e o terceiro dígitos
        cnpj_cnpf=cnpj_cnpf.replace(/^(\d{2})(\d)/,"$1.$2")
 
        //Coloca ponto entre o quinto e o sexto dígitos
        cnpj_cnpf=cnpj_cnpf.replace(/^(\d{2})\.(\d{3})(\d)/,"$1.$2.$3")
 
        //Coloca uma barra entre o oitacnpj_cnpfo e o nono dígitos
        cnpj_cnpf=cnpj_cnpf.replace(/\.(\d{3})(\d)/,".$1/$2")
 
        //Coloca um hífen depois do bloco de quatro dígitos
        cnpj_cnpf=cnpj_cnpf.replace(/(\d{4})(\d)/,"$1-$2")
 
    }
 
    return cnpj_cnpf
 
}